"use strict";

exports.__esModule = true;
exports["default"] = createPath;
function createPath(_ref) {
  var pathname = _ref.pathname,
    search = _ref.search,
    hash = _ref.hash;
  return "" + pathname + search + hash;
}
module.exports = exports["default"];